export const TolgeeHelpers = {
  sanitizeTranslationForUrls: (t: string) => {
    return t
      .replace(/<[^>]+>/g, '') // Remove HTML tags
      .replace(/&nbsp;/g, ' ') // Replace non-breaking spaces with regular spaces
      .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .trim() // Trim leading and trailing spaces
  },
}
